import { ContentCategory } from '@brovicms/models';

/**
 * Common Content Categories
 * Categories shared between eBooks and eAudio
 */
const COMMON_CATEGORIES: ContentCategory[] = [
  {
    id: 'self-experience',
    name: 'आत्म अनुभव',
    slug: 'self-experience',
    description: 'Self Experience',
    isActive: true,
    sortOrder: 1,
  },
  {
    id: 'matters-of-heart',
    name: 'दिल की बातें',
    slug: 'matters-of-heart',
    description: 'Matters of the Heart',
    isActive: true,
    sortOrder: 2,
  },
  {
    id: 'heart-touching-words',
    name: 'दिल छूने वाली बातें',
    slug: 'heart-touching-words',
    description: 'Heart-touching Words',
    isActive: true,
    sortOrder: 3,
  },
  {
    id: 'detached-life',
    name: 'निर्विकार जीवन',
    slug: 'detached-life',
    description: 'Detached Life',
    isActive: true,
    sortOrder: 4,
  },
  {
    id: 'intensity-in-effort',
    name: 'पुरुषार्थ में तीव्रता',
    slug: 'intensity-in-effort',
    description: 'Intensity in Effort',
    isActive: true,
    sortOrder: 5,
  },
  {
    id: 'yoga-method-commentary',
    name: 'योग विधि व कमेंट्री',
    slug: 'yoga-method-commentary',
    description: 'Yoga Method & Commentary',
    isActive: true,
    sortOrder: 6,
  },
  {
    id: 'willpower',
    name: 'संकल्प शक्ति',
    slug: 'willpower',
    description: 'Willpower',
    isActive: true,
    sortOrder: 7,
  },
  {
    id: 'peaceful-mind',
    name: 'शांत मन',
    slug: 'peaceful-mind',
    description: 'Peaceful Mind',
    isActive: true,
    sortOrder: 8,
  },
  {
    id: 'secret-of-karma',
    name: 'कर्म रहस्य',
    slug: 'secret-of-karma',
    description: 'Secret of Karma',
    isActive: true,
    sortOrder: 9,
  },
  {
    id: 'source-of-inspiration',
    name: 'प्रेरणा स्रोत',
    slug: 'source-of-inspiration',
    description: 'Source of Inspiration',
    isActive: true,
    sortOrder: 10,
  },
];

/**
 * E-Audio specific categories
 */
const EAUDIO_SPECIFIC_CATEGORIES: ContentCategory[] = [
  {
    id: 'ebook-audio',
    name: 'ई-बुक ऑडियो',
    slug: 'ebook-audio',
    description: 'E-Book Audio',
    isActive: true,
    sortOrder: 11,
  },
];

/**
 * E-Book Categories
 * Only common categories for eBooks
 */
export const EBOOK_CATEGORIES: ContentCategory[] = [...COMMON_CATEGORIES];

/**
 * E-Audio Categories
 * Common categories + eAudio specific categories
 */
export const EAUDIO_CATEGORIES: ContentCategory[] = [
  ...COMMON_CATEGORIES,
  ...EAUDIO_SPECIFIC_CATEGORIES,
];

/**
 * All Content Categories
 * Complete list of all categories (alias for COMMON_CATEGORIES)
 */
export const CONTENT_CATEGORIES: ContentCategory[] = [...COMMON_CATEGORIES, ...EAUDIO_SPECIFIC_CATEGORIES];